<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"  @btnclick="bthClick" :pageData="pageData"></table-page>
  </div>
</template>

<script>
  //table封装组件
  import tablePage from '@/components/page/table.vue'
  import FORM from '@/components/page/form.vue'
  import Url from '@/views/proxy_cfint/util/url'
  import DateUtil from '@/utils/IM/tradeDataUtil'
  import Qs from 'qs'
  let status = {1:"是",2:"否"}
  export default {
    name: 'list',
    components: {
      tablePage,
      FORM,
    },
    methods: {
      bthClick (clickName, row) {
        if (clickName == "freeze"){
          this.dataChanage(Url.adAgent.creditInfo.freeze,{"id":row.id},res => {
            if (res.code == 0){
              this.$message.success("suc");
            }else{
              this.$message.error(res.message);
            }
          })
        }else if(clickName == "unfreeze"){
          this.dataChanage(Url.adAgent.creditInfo.unfreeze,{"id":row.id},res => {
            if (res.code == 0){
              this.$message.success("suc");
            }else{
              this.$message.error(res.message);
            }
          })
        }
      },
      /*查询表单按钮点击事件*/
      formclick(clickName, data){
        if("查询" == clickName){
          this.queryData = data;
          this.queryData.platform = (this.flag == 1?"BO":"GTS2");
          this.$refs.childTable.defaultQueryData(this.queryData);
        }
      },
      dataChanage(url,option,suc,fail){
        this.axios.post(url, Qs.stringify(option || {})).then(res => {
          if(suc && (typeof suc == 'function')) suc(res);
          this.$refs.childTable.defaultGetData(this.queryData);
        }).catch(res => {
          if(fail && (typeof fail == 'function')) fail(res);
          this.$refs.childTable.defaultGetData(this.queryData);
        })
      },
    },
    data () {
      return {
        flag: DateUtil.getParamKey(this.$route.params),
        queryData:{},
        /*新增或更新*/
        /*from查询表单*/
        formData:{
          hasLable: true,
          cols:[
            { title: '代理编码', field: 'agentCode'},
            { title: '代理名称', field: 'name'},
            { click:"查询",auth:"proxy_cfint:creditInfo:query"},
          ]
        },
        /*table生成*/
        pageData: {
          queryUrl: Url.adAgent.creditInfo.list, //请求路径和参数
          //selection: true,
          sequence: true,
          cols: [
            { title: '代理编码', field: 'agentCode'},
            { title: '关联交易账号', field: 'agentNumber'},
            { title: '代理名称', field: 'name'},
            { title: '授信总额度', field: 'creditLine'},
            { title: '已授信额度', field: 'creditLineUsed'},
            { title: '剩余授信额度', field: 'creditLineUsed',render:(data, full) => {
                return full.creditLine - full.creditLineUsed;
              }},
            { title: '当前授信客户数', field: 'creditLinePeople'},
            { title: '当前授信客户净值总额', field: 'equity'},
            { title: '授信总额占比', field: 'creditLineUsed',render:(data, full) => {
                return (100*((full.creditLine - (full.creditLineUsed || 0) + (full.equity || 0))/full.creditLine)).toFixed(2)+"%";
              }},
            { title: '冻结状态', field: 'status',render:(data, full) => {
                return status[data];
              }},
            { title: '冻结人', field: 'freezeUser'},
            { title: '冻结时间', field: 'freezeTime', render: (data, full) => {
                return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
              }},
            { title: '解冻人', field: 'unfreezeUser'},
            { title: '解冻时间', field: 'unfreezeTime', render: (data, full) => {
                return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
              }},
            {title:"操作", btnClick: [
                { name: "解冻", size: 'mini', click: 'unfreeze', type: 'primary' ,icon:"el-icon-update",hidden:(data,full)=>{
                    return full.status == 2;
                  },auth:"proxy_cfint:creditInfo:unfreeze",confirm:"您确定要解冻吗"},
                { name: "冻结", size: 'mini', click: 'freeze', type: 'primary' ,icon:"el-icon-update",hidden:(data,full)=>{
                    return full.status == 1;
                  },auth:"proxy_cfint:creditInfo:freeze",confirm:"您确定要冻结吗"}]
            }
        ]
      }
    }
  }
}
</script>
